module.exports = __webpack_public_path__ + "static/media/cover.56cd0501.png";